import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component';
import { SupervisionError } from 'solar-bo';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { DBG, DebugLevelEnum } from '@solar/shared/dbg.model';
import { NotificationType } from 'base-models';
import { dateInputsHaveChanged } from '@angular/material/datepicker/datepicker-input-base';
import { OMItem } from '@solar/solar/models/omitem.model';


@Component({
  selector: 'app-oper-mant',
  templateUrl: './opermant.component.html',
  styleUrls: ['./opermant.component.scss']
})
export class OperMantComponent extends SolarBaseComponent implements OnInit, OnChanges {


  //ISSUE LIST
  issueList: SupervisionError[];
  singleEdit: boolean = true;


  panelInfo: string;
  isValidator: boolean = false;
  issueSavedEvent: EventEmitter<any> = new EventEmitter();


  constructor(
    private fb: FormBuilder
    , public solarService: SolarService
  ) {
    super();
    this.loadinglist = false;
    this.createForm();

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    /*     const typeChange = changes['supervision'];
        if (typeChange && !typeChange.firstChange && typeChange.previousValue == undefined) {
    
        } */
  }

  private createForm() {
    let dateNow = new Date();
    this.myform = this.fb.group({
      status: ['', [Validators.required]],
      panel_serial: [''],
      comments: [''],
      reviewedDate: [dateNow, [Validators.required]],
    });
  }

  private setForm(issue:SupervisionError) {
    let om = issue.info["om"];
    if (!om) {
      return;
    }

    let reviewedDate = om.reviewedDate;
    if (reviewedDate == null) {
      reviewedDate = new Date();
    }

    const fields = {
      status: om.status,
      comments: om.comments,
      panel_serial: om.panel_serial,
      reviewedDate: reviewedDate,
    };

    this.myform.reset(fields);
  }


  public static openDialog(dialog: MatDialog, model: any): MatDialogRef<OperMantComponent> {

    let dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "650px";


    //dialogConfig.data = { model: model, title: title, message: message, actioncaption: actioncaption }
    return dialog.open(OperMantComponent, dialogConfig);

  }

  isvalid() {
    return this.myform.valid && !this.submitted;
  }

  configIssueList(issues: SupervisionError[]) {
    this.issueList = issues;
    if (issues.length == 1) {
      this.singleEdit = true;
      let oneIssue: SupervisionError = issues[0];
      this.panelInfo = oneIssue.info.panel.name;
      this.setForm(oneIssue);
    } else if (issues.length > 1) {
      this.singleEdit = false;
      this.panelInfo = "Apply to " + issues.length + " issues selected";
    }
  }

  prepareSave(issueToSave:SupervisionError): any {
    //como ejemplo, en nuestro caso es el mismo objeto
    const formModel = this.myform.value;

    let om: OMItem = new OMItem()

    om.status = formModel.status;
    om.reviewedDate = formModel.reviewedDate;
    om.panel_serial = formModel.panel_serial;
    om.comments = formModel.comments;
    om.modify_user = this.globService.currentUserValue.id;
    om.modify_date = new Date();

    const issue = new SupervisionError();
    issue.info = issueToSave.info;
    issue.id = issueToSave.id;
    issue.info["om"] = om;

    return issue;
  }

  saveModel() {
    this.saveIssue();
  }

  saveIssue() {
    this.submitted = true;
    this.listerrmessage = "";
    this.alertmessage = null;
    this.loading = true;

    //if (this.singleEdit) 
    for (let issueToSave of this.issueList){
      let issueCloned= this.prepareSave(issueToSave);
      this.solarService.supervisionIssueUpdate(issueCloned)
        .subscribe(
          issueSavedResult => this.saveIssueHandleresult(issueToSave,issueSavedResult)
          , err => this.saveIssueHandleError(err)
        );      
    }
  }

  saveIssueHandleError<T>(err: any) {
    this.loading = false;
    this.submitted = false;
    this.handleError(err, "Error updating issue ");
  }

  saveIssueHandleresult(issueToSave:SupervisionError, issueSaved: SupervisionError) {


    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, 'saveIssueHandleresult', issueSaved);
    this.listerrmessage = '';
    this.loading = false;
    this.submitted = false;
    //como el servidor devuelve el issue con datos simples hay que asignar algunos datos
    issueToSave.om = issueSaved.info.om;


    this.showNotification(NotificationType.Success, "Panel " + issueToSave.info.panel.name + " saved");
    this.issueSavedEvent.emit(issueSaved);

  }

  OMItem_getDescription(status: string) {
    return OMItem.getDescription(status);
  }

}
